import {SSAFY9_CODE, SSAFY10_CODE, SSAFY11_CODE} from "./ssafy";

export const SEN_CODE = "SENSWED123";
export const ICE_CODE = "ICESWED123";
export const TECHLYMPIC = "TECHLYMPIC";
export const SWCHTU2023 = "SWCHTU2023";
export const GANGWON_CODE = "GANGWON2024";
export const SEDIGIHISC_CODE = "SEDIGIHISC";

export const USER_GROUP = {
  SEN_CODE,
  ICE_CODE,
  TECHLYMPIC,
  SWCHTU2023,
  SSAFY9_CODE,
  SSAFY10_CODE,
  SSAFY11_CODE,
  GANGWON_CODE,
  SEDIGIHISC_CODE,
};
export const CLASS_CODE_LIST = [SEN_CODE, ICE_CODE, GANGWON_CODE, SEDIGIHISC_CODE];

export const SEN_ORGANIZATIONS = [
  "전체",
  "가락고등학교",
  "가락중학교",
  "가산중학교",
  "가원중학교",
  "가재울고등학교",
  "가재울중학교",
  "강남중학교",
  "강동고등학교",
  "강동중학교",
  "강명중학교",
  "강북중학교",
  "강빛중학교",
  "강서고등학교",
  "강서공업고등학교",
  "강신중학교",
  "강일고등학교",
  "강일중학교",
  "강현중학교",
  "개봉중학교",
  "개운중학교",
  "개웅중학교",
  "개원중학교",
  "개포고등학교",
  "개포중학교",
  "거원중학교",
  "건국대학교사범대학부속고등학교",
  "건국대학교사범대학부속중학교",
  "경기고등학교",
  "경기기계공업고등학교",
  "경기상업고등학교",
  "경기여자고등학교",
  "경기여자고등학교부설방송통신고등학교",
  "경기초등학교",
  "경동고등학교",
  "경동고등학교부설방송통신고등학교",
  "경문고등학교",
  "경복고등학교",
  "경복고등학교부설방송통신고등학교",
  "경복비즈니스고등학교",
  "경복여자고등학교",
  "경복초등학교",
  "경서중학교",
  "경성고등학교",
  "경성중학교",
  "경수중학교",
  "경신고등학교",
  "경신중학교",
  "경원중학교",
  "경인고등학교",
  "경인중학교",
  "경일고등학교",
  "경일중학교",
  "경희고등학교",
  "경희여자고등학교",
  "경희여자중학교",
  "경희중학교",
  "경희초등학교",
  "계성고등학교",
  "계성초등학교",
  "고덕중학교",
  "고려대학교사범대학부속고등학교",
  "고려대학교사범대학부속중학교",
  "고명외식고등학교",
  "고명중학교",
  "고척고등학교",
  "고척중학교",
  "공릉중학교",
  "공립위탁형대안교육꿈타래학교",
  "공진중학교",
  "공항고등학교",
  "공항중학교",
  "관악고등학교",
  "관악중학교",
  "광남고등학교",
  "광남중학교",
  "광문고등학교",
  "광성고등학교",
  "광성중학교",
  "광성하늘빛학교",
  "광신고등학교",
  "광신방송예술고등학교",
  "광신중학교",
  "광양고등학교",
  "광양중학교",
  "광영고등학교",
  "광영여자고등학교",
  "광운전자공업고등학교",
  "광운중학교",
  "광운초등학교",
  "광장중학교",
  "광진중학교",
  "광희중학교",
  "교남학교",
  "구로고등학교",
  "구로중학교",
  "구룡중학교",
  "구산중학교",
  "구암고등학교",
  "구암중학교",
  "구의중학교",
  "구일고등학교",
  "구일중학교",
  "구현고등학교",
  "국립국악고등학교",
  "국립국악중학교",
  "국립서울농학교",
  "국립서울맹학교",
  "국립전통예술고등학교",
  "국립전통예술중학교",
  "국사봉중학교",
  "금성초등학교",
  "금옥여자고등학교",
  "금옥중학교",
  "금천고등학교",
  "금천문화예술정보학교",
  "금호고등학교",
  "금호여자중학교",
  "길음중학교",
  "난곡중학교",
  "난우중학교",
  "남강고등학교",
  "남강중학교",
  "남대문중학교",
  "남서울중학교",
  "남성중학교",
  "내곡중학교",
  "노곡중학교",
  "노원고등학교",
  "노원중학교",
  "노일중학교",
  "녹천중학교",
  "누리학교",
  "누원고등학교",
  "다니엘학교",
  "단국대학교부속소프트웨어고등학교",
  "단국대학교사범대학부속고등학교",
  "단국대학교사범대학부속중학교",
  "당곡고등학교",
  "당곡중학교",
  "당산서중학교",
  "당산중학교",
  "대경생활과학고등학교",
  "대경중학교",
  "대광고등학교",
  "대광중학교",
  "대광초등학교",
  "대동세무고등학교",
  "대림중학교",
  "대명중학교",
  "대방중학교",
  "대성고등학교",
  "대성중학교",
  "대신고등학교",
  "대신중학교",
  "대영고등학교",
  "대영중학교",
  "대왕중학교",
  "대원고등학교",
  "대원국제중학교",
  "대원여자고등학교",
  "대원외국어고등학교",
  "대일고등학교",
  "대일관광고등학교",
  "대일외국어고등학교",
  "대진고등학교",
  "대진디자인고등학교",
  "대진여자고등학교",
  "대청중학교",
  "대치중학교",
  "덕산중학교",
  "덕성여자고등학교",
  "덕성여자중학교",
  "덕수고등학교",
  "덕수중학교",
  "덕원여자고등학교",
  "덕원예술고등학교",
  "덕원중학교",
  "덕일전자공업고등학교",
  "도곡중학교",
  "도봉고등학교",
  "도봉중학교",
  "도선고등학교",
  "독산고등학교",
  "동광초등학교",
  "동구마케팅고등학교",
  "동구여자중학교",
  "동국대학교사범대학부속고등학교",
  "동국대학교사범대학부속여자고등학교",
  "동국대학교사범대학부속여자중학교",
  "동국대학교사범대학부속중학교",
  "동대문중학교",
  "동덕여자고등학교",
  "동덕여자중학교",
  "동도중학교",
  "동마중학교",
  "동명생활경영고등학교",
  "동명여자고등학교",
  "동명여자중학교",
  "동북고등학교",
  "동북중학교",
  "동북초등학교",
  "동산고등학교",
  "동산초등학교",
  "동성고등학교",
  "동성중학교",
  "동신중학교",
  "동양고등학교",
  "동양중학교",
  "동원중학교",
  "동일여자고등학교",
  "동일중학교",
  "동작고등학교",
  "동작중학교",
  "둔촌고등학교",
  "둔촌중학교",
  "등명중학교",
  "등원중학교",
  "등촌고등학교",
  "등촌중학교",
  "리라아트고등학교",
  "리라초등학교",
  "마곡중학교",
  "마곡하늬중학교",
  "마장중학교",
  "마포고등학교",
  "마포중학교",
  "매원초등학교",
  "면목고등학교",
  "면목중학교",
  "명덕고등학교",
  "명덕여자고등학교",
  "명덕여자중학교",
  "명덕외국어고등학교",
  "명일여자고등학교",
  "명일중학교",
  "명지고등학교",
  "명지중학교",
  "명지초등학교",
  "목동고등학교",
  "목동중학교",
  "목운중학교",
  "목일중학교",
  "무학여자고등학교",
  "무학중학교",
  "문래중학교",
  "문성중학교",
  "문일고등학교",
  "문일중학교",
  "문정고등학교",
  "문정중학교",
  "문창중학교",
  "문현고등학교",
  "문현중학교",
  "미래산업과학고등학교",
  "미림여자고등학교",
  "미림여자정보과학고등학교",
  "미성중학교",
  "미양고등학교",
  "미양중학교",
  "밀알학교",
  "반포고등학교",
  "반포중학교",
  "방배중학교",
  "방산고등학교",
  "방산중학교",
  "방원중학교",
  "방이중학교",
  "방학중학교",
  "방화중학교",
  "배명고등학교",
  "배명중학교",
  "배문고등학교",
  "배문중학교",
  "배재고등학교",
  "배재중학교",
  "배화여자고등학교",
  "배화여자중학교",
  "백석중학교",
  "백암고등학교",
  "백운중학교",
  "번동중학교",
  "보성고등학교",
  "보성여자고등학교",
  "보성여자중학교",
  "보성중학교",
  "보인고등학교",
  "보인중학교",
  "봉림중학교",
  "봉영여자중학교",
  "봉원중학교",
  "봉은중학교",
  "봉화중학교",
  "북서울중학교",
  "북악중학교",
  "불광중학교",
  "불암고등학교",
  "불암중학교",
  "사당중학교",
  "삼각산고등학교",
  "삼각산중학교",
  "삼선중학교",
  "삼성고등학교",
  "삼성중학교",
  "삼정중학교",
  "상경중학교",
  "상계고등학교",
  "상계제일중학교",
  "상계중학교",
  "상도중학교",
  "상명고등학교",
  "상명대학교사범대학부속여자고등학교",
  "상명대학교사범대학부속여자중학교",
  "상명대학교사범대학부속초등학교",
  "상명중학교",
  "상명초등학교",
  "상문고등학교",
  "상봉중학교",
  "상신중학교",
  "상암고등학교",
  "상암중학교",
  "상원중학교",
  "상일미디어고등학교",
  "상일여자고등학교",
  "상일여자중학교",
  "상현중학교",
  "서라벌고등학교",
  "서라벌중학교",
  "서문여자고등학교",
  "서문여자중학교",
  "서서울생활과학고등학교",
  "서연중학교",
  "서운중학교",
  "서울가곡초등학교",
  "서울가동초등학교",
  "서울가락초등학교",
  "서울가산초등학교",
  "서울가양초등학교",
  "서울가원초등학교",
  "서울가인초등학교",
  "서울가재울초등학교",
  "서울가주초등학교",
  "서울갈산초등학교",
  "서울갈현초등학교",
  "서울강남초등학교",
  "서울강덕초등학교",
  "서울강동초등학교",
  "서울강명초등학교",
  "서울강빛초등학교",
  "서울강서초등학교",
  "서울강솔초등학교",
  "서울강신초등학교",
  "서울강월초등학교",
  "서울강일초등학교",
  "서울개롱초등학교",
  "서울개명초등학교",
  "서울개봉초등학교",
  "서울개운초등학교",
  "서울개웅초등학교",
  "서울개원초등학교",
  "서울개일초등학교",
  "서울개포초등학교",
  "서울개화초등학교",
  "서울거여초등학교",
  "서울거원초등학교",
  "서울경동초등학교",
  "서울경수초등학교",
  "서울경운학교",
  "서울경인초등학교",
  "서울경일초등학교",
  "서울계남초등학교",
  "서울계상초등학교",
  "서울고덕초등학교",
  "서울고등학교",
  "서울고명초등학교",
  "서울고산초등학교",
  "서울고원초등학교",
  "서울고은초등학교",
  "서울고일초등학교",
  "서울고척초등학교",
  "서울고현초등학교",
  "서울공덕초등학교",
  "서울공릉초등학교",
  "서울공업고등학교",
  "서울공업고등학교공동실습소",
  "서울공연예술고등학교",
  "서울공연초등학교",
  "서울공진초등학교",
  "서울공항초등학교",
  "서울과학고등학교",
  "서울관광고등학교",
  "서울관악초등학교",
  "서울광남초등학교",
  "서울광장초등학교",
  "서울광진초등학교",
  "서울광진학교",
  "서울광희초등학교",
  "서울교동초등학교",
  "서울교육대학교부설초등학교",
  "서울구남초등학교",
  "서울구로남초등학교",
  "서울구로초등학교",
  "서울구룡초등학교",
  "서울구산초등학교",
  "서울구암초등학교",
  "서울구의초등학교",
  "서울구일초등학교",
  "서울구현초등학교",
  "서울국제고등학교",
  "서울군자초등학교",
  "서울금나래초등학교",
  "서울금동초등학교",
  "서울금북초등학교",
  "서울금산초등학교",
  "서울금양초등학교",
  "서울금옥초등학교",
  "서울금융고등학교",
  "서울금천초등학교",
  "서울금호초등학교",
  "서울금화초등학교",
  "서울길동초등학교",
  "서울길원초등학교",
  "서울길음초등학교",
  "서울나래학교",
  "서울난곡초등학교",
  "서울난우초등학교",
  "서울난향초등학교",
  "서울남명초등학교",
  "서울남부초등학교",
  "서울남사초등학교",
  "서울남산초등학교",
  "서울남성초등학교",
  "서울남정초등학교",
  "서울남천초등학교",
  "서울내발산초등학교",
  "서울노량진초등학교",
  "서울노원초등학교",
  "서울노일초등학교",
  "서울녹번초등학교",
  "서울녹천초등학교",
  "서울논현초등학교",
  "서울누원초등학교",
  "서울다솜관광고등학교",
  "서울다원학교",
  "서울답십리초등학교",
  "서울당곡초등학교",
  "서울당산초등학교",
  "서울당서초등학교",
  "서울당중초등학교",
  "서울당현초등학교",
  "서울대곡초등학교",
  "서울대길초등학교",
  "서울대도초등학교",
  "서울대동초등학교",
  "서울대림초등학교",
  "서울대명초등학교",
  "서울대모초등학교",
  "서울대방초등학교",
  "서울대신초등학교",
  "서울대영초등학교",
  "서울대왕초등학교",
  "서울대은초등학교",
  "서울대조초등학교",
  "서울대진초등학교",
  "서울대청초등학교",
  "서울대치초등학교",
  "서울대학교사범대학부설고등학교",
  "서울대학교사범대학부설여자중학교",
  "서울대학교사범대학부설중학교",
  "서울대학교사범대학부설초등학교",
  "서울대현초등학교",
  "서울덕수초등학교",
  "서울덕암초등학교",
  "서울덕의초등학교",
  "서울도곡초등학교",
  "서울도림초등학교",
  "서울도봉초등학교",
  "서울도성초등학교",
  "서울도솔학교",
  "서울도시과학기술고등학교",
  "서울도신초등학교",
  "서울독립문초등학교",
  "서울독산초등학교",
  "서울돈암초등학교",
  "서울동교초등학교",
  "서울동구로초등학교",
  "서울동답초등학교",
  "서울동명초등학교",
  "서울동신초등학교",
  "서울동원초등학교",
  "서울동의초등학교",
  "서울동일초등학교",
  "서울동자초등학교",
  "서울동작초등학교",
  "서울동천학교",
  "서울동호초등학교",
  "서울두산초등학교",
  "서울둔촌초등학교",
  "서울등마초등학교",
  "서울등명초등학교",
  "서울등서초등학교",
  "서울등양초등학교",
  "서울등원초등학교",
  "서울등촌초등학교",
  "서울등현초등학교",
  "서울디자인고등학교",
  "서울디지텍고등학교",
  "서울로봇고등학교",
  "서울마장초등학교",
  "서울마천초등학교",
  "서울마포초등학교",
  "서울망우초등학교",
  "서울망원초등학교",
  "서울매그넷고등학교",
  "서울매동초등학교",
  "서울매봉초등학교",
  "서울매헌초등학교",
  "서울면남초등학교",
  "서울면동초등학교",
  "서울면목초등학교",
  "서울면북초등학교",
  "서울면일초등학교",
  "서울면중초등학교",
  "서울명덕초등학교",
  "서울명신초등학교",
  "서울명원초등학교",
  "서울명일초등학교",
  "서울목동초등학교",
  "서울목운초등학교",
  "서울목원초등학교",
  "서울묘곡초등학교",
  "서울무학초등학교",
  "서울묵동초등학교",
  "서울묵현초등학교",
  "서울문교초등학교",
  "서울문덕초등학교",
  "서울문래초등학교",
  "서울문백초등학교",
  "서울문성초등학교",
  "서울문영여자고등학교",
  "서울문영여자중학교",
  "서울문정초등학교",
  "서울문창초등학교",
  "서울문현초등학교",
  "서울문화고등학교",
  "서울미동초등학교",
  "서울미래초등학교",
  "서울미성초등학교",
  "서울미술고등학교",
  "서울미아초등학교",
  "서울미양초등학교",
  "서울반원초등학교",
  "서울반포초등학교",
  "서울발산초등학교",
  "서울방배초등학교",
  "서울방산초등학교",
  "서울방송고등학교",
  "서울방이초등학교",
  "서울방일초등학교",
  "서울방학초등학교",
  "서울방현초등학교",
  "서울방화초등학교",
  "서울배봉초등학교",
  "서울백산초등학교",
  "서울백석초등학교",
  "서울백운초등학교",
  "서울버들초등학교",
  "서울번동초등학교",
  "서울보광초등학교",
  "서울보라매초등학교",
  "서울본동초등학교",
  "서울봉래초등학교",
  "서울봉은초등학교",
  "서울봉천초등학교",
  "서울봉현초등학교",
  "서울봉화초등학교",
  "서울북가좌초등학교",
  "서울북성초등학교",
  "서울북한산초등학교",
  "서울불광초등학교",
  "서울불암초등학교",
  "서울사근초등학교",
  "서울사당초등학교",
  "서울산업정보학교",
  "서울삼각산초등학교",
  "서울삼광초등학교",
  "서울삼릉초등학교",
  "서울삼선초등학교",
  "서울삼성초등학교",
  "서울삼성학교",
  "서울삼양초등학교",
  "서울삼육초등학교",
  "서울삼일초등학교",
  "서울삼전초등학교",
  "서울삼정초등학교",
  "서울상경초등학교",
  "서울상계초등학교",
  "서울상곡초등학교",
  "서울상도초등학교",
  "서울상봉초등학교",
  "서울상수초등학교",
  "서울상신초등학교",
  "서울상암초등학교",
  "서울상원초등학교",
  "서울상월초등학교",
  "서울상일초등학교",
  "서울상지초등학교",
  "서울상천초등학교",
  "서울상현초등학교",
  "서울새롬학교",
  "서울새솔초등학교",
  "서울서강초등학교",
  "서울서교초등학교",
  "서울서래초등학교",
  "서울서빙고초등학교",
  "서울서신초등학교",
  "서울서원초등학교",
  "서울서이초등학교",
  "서울서일초등학교",
  "서울서정초등학교",
  "서울서진학교",
  "서울서초초등학교",
  "서울석계초등학교",
  "서울석관초등학교",
  "서울석촌초등학교",
  "서울선곡초등학교",
  "서울선린초등학교",
  "서울선사초등학교",
  "서울선유초등학교",
  "서울성내초등학교",
  "서울성북초등학교",
  "서울성산초등학교",
  "서울성서초등학교",
  "서울성수초등학교",
  "서울성원초등학교",
  "서울성일초등학교",
  "서울성자초등학교",
  "서울세검정초등학교",
  "서울세곡초등학교",
  "서울세륜초등학교",
  "서울세명초등학교",
  "서울세종고등학교",
  "서울소의초등학교",
  "서울송례초등학교",
  "서울송원초등학교",
  "서울송전초등학교",
  "서울송정초등학교",
  "서울송중초등학교",
  "서울송천초등학교",
  "서울송파초등학교",
  "서울송화초등학교",
  "서울수락초등학교",
  "서울수리초등학교",
  "서울수명초등학교",
  "서울수색초등학교",
  "서울수서초등학교",
  "서울수송초등학교",
  "서울수암초등학교",
  "서울수유초등학교",
  "서울숭곡초등학교",
  "서울숭덕초등학교",
  "서울숭례초등학교",
  "서울숭미초등학교",
  "서울숭신초등학교",
  "서울숭인초등학교",
  "서울시흥초등학교",
  "서울신가초등학교",
  "서울신강초등학교",
  "서울신계초등학교",
  "서울신곡초등학교",
  "서울신구로초등학교",
  "서울신구초등학교",
  "서울신기초등학교",
  "서울신길초등학교",
  "서울신남성초등학교",
  "서울신남초등학교",
  "서울신내초등학교",
  "서울신답초등학교",
  "서울신당초등학교",
  "서울신대림초등학교",
  "서울신도림초등학교",
  "서울신도초등학교",
  "서울신동초등학교",
  "서울신림초등학교",
  "서울신명초등학교",
  "서울신목초등학교",
  "서울신묵초등학교",
  "서울신미림초등학교",
  "서울신방학초등학교",
  "서울신봉초등학교",
  "서울신북초등학교",
  "서울신사초등학교",
  "서울신상계초등학교",
  "서울신상도초등학교",
  "서울신서초등학교",
  "서울신석초등학교",
  "서울신성초등학교",
  "서울신암초등학교",
  "서울신양초등학교",
  "서울신영초등학교",
  "서울신용산초등학교",
  "서울신우초등학교",
  "서울신원초등학교",
  "서울신월초등학교",
  "서울신은초등학교",
  "서울신자초등학교",
  "서울신정고등학교",
  "서울신정초등학교",
  "서울신중초등학교",
  "서울신창초등학교",
  "서울신천초등학교",
  "서울신학초등학교",
  "서울신현초등학교",
  "서울신화초등학교",
  "서울신흥초등학교",
  "서울실용음악고등학교",
  "서울쌍문초등학교",
  "서울아이티고등학교",
  "서울아주초등학교",
  "서울아현초등학교",
  "서울안산초등학교",
  "서울안암초등학교",
  "서울안천초등학교",
  "서울안평초등학교",
  "서울압구정초등학교",
  "서울애화학교",
  "서울양강초등학교",
  "서울양남초등학교",
  "서울양동초등학교",
  "서울양명초등학교",
  "서울양목초등학교",
  "서울양원초등학교",
  "서울양재초등학교",
  "서울양전초등학교",
  "서울양진초등학교",
  "서울양천초등학교",
  "서울양화초등학교",
  "서울어울초등학교",
  "서울언남초등학교",
  "서울언북초등학교",
  "서울언주초등학교",
  "서울여의도초등학교",
  "서울여자고등학교",
  "서울여자상업고등학교",
  "서울여자중학교",
  "서울역삼초등학교",
  "서울역촌초등학교",
  "서울연가초등학교",
  "서울연광초등학교",
  "서울연신초등학교",
  "서울연은초등학교",
  "서울연지초등학교",
  "서울연천초등학교",
  "서울연촌초등학교",
  "서울연희미용고등학교",
  "서울연희초등학교",
  "서울염강초등학교",
  "서울염경초등학교",
  "서울염동초등학교",
  "서울염리초등학교",
  "서울염창초등학교",
  "서울영남초등학교",
  "서울영도초등학교",
  "서울영동초등학교",
  "서울영등포초등학교",
  "서울영림초등학교",
  "서울영문초등학교",
  "서울영본초등학교",
  "서울영상고등학교",
  "서울영서초등학교",
  "서울영신초등학교",
  "서울영원초등학교",
  "서울영일초등학교",
  "서울영중초등학교",
  "서울영풍초등학교",
  "서울영화초등학교",
  "서울영희초등학교",
  "서울예술고등학교",
  "서울오금초등학교",
  "서울오류남초등학교",
  "서울오류초등학교",
  "서울오륜초등학교",
  "서울오봉초등학교",
  "서울오정초등학교",
  "서울오현초등학교",
  "서울옥수초등학교",
  "서울옥정초등학교",
  "서울온곡초등학교",
  "서울온수초등학교",
  "서울왕북초등학교",
  "서울외국어고등학교",
  "서울용강초등학교",
  "서울용곡초등학교",
  "서울용답초등학교",
  "서울용동초등학교",
  "서울용두초등학교",
  "서울용마초등학교",
  "서울용산초등학교",
  "서울용암초등학교",
  "서울용원초등학교",
  "서울우면초등학교",
  "서울우솔초등학교",
  "서울우신초등학교",
  "서울우암초등학교",
  "서울우이초등학교",
  "서울우장초등학교",
  "서울원광초등학교",
  "서울원당초등학교",
  "서울원명초등학교",
  "서울원묵초등학교",
  "서울원신초등학교",
  "서울원촌초등학교",
  "서울원효초등학교",
  "서울월계초등학교",
  "서울월곡초등학교",
  "서울월정초등학교",
  "서울월천초등학교",
  "서울월촌초등학교",
  "서울위례별초등학교",
  "서울위례솔초등학교",
  "서울위례초등학교",
  "서울유현초등학교",
  "서울윤중초등학교",
  "서울율현초등학교",
  "서울은로초등학교",
  "서울은명초등학교",
  "서울은빛초등학교",
  "서울은정초등학교",
  "서울은진초등학교",
  "서울은천초등학교",
  "서울은평초등학교",
  "서울을지초등학교",
  "서울응봉초등학교",
  "서울응암초등학교",
  "서울의료보건고등학교",
  "서울이문초등학교",
  "서울이수초등학교",
  "서울이태원초등학교",
  "서울인수초등학교",
  "서울인왕초등학교",
  "서울인헌초등학교",
  "서울일신초등학교",
  "서울일원초등학교",
  "서울자곡초등학교",
  "서울자동차고등학교",
  "서울자양초등학교",
  "서울자운초등학교",
  "서울잠동초등학교",
  "서울잠신초등학교",
  "서울잠실초등학교",
  "서울잠원초등학교",
  "서울잠일초등학교",
  "서울잠전초등학교",
  "서울잠현초등학교",
  "서울장곡초등학교",
  "서울장수초등학교",
  "서울장안초등학교",
  "서울장월초등학교",
  "서울장위초등학교",
  "서울장충초등학교",
  "서울장평초등학교",
  "서울재동초등학교",
  "서울전곡초등학교",
  "서울전농초등학교",
  "서울전동초등학교",
  "서울전자고등학교",
  "서울정곡초등학교",
  "서울정덕초등학교",
  "서울정릉초등학교",
  "서울정목초등학교",
  "서울정문학교",
  "서울정민학교",
  "서울정수초등학교",
  "서울정심초등학교",
  "서울정애학교",
  "서울정인학교",
  "서울정진학교",
  "서울조원초등학교",
  "서울종암초등학교",
  "서울중계초등학교",
  "서울중곡초등학교",
  "서울중광초등학교",
  "서울중대초등학교",
  "서울중동초등학교",
  "서울중랑초등학교",
  "서울중마초등학교",
  "서울중목초등학교",
  "서울중원초등학교",
  "서울중평초등학교",
  "서울중현초등학교",
  "서울중화초등학교",
  "서울중흥초등학교",
  "서울증산초등학교",
  "서울지향초등학교",
  "서울진관초등학교",
  "서울창경초등학교",
  "서울창도초등학교",
  "서울창동초등학교",
  "서울창림초등학교",
  "서울창서초등학교",
  "서울창신초등학교",
  "서울창원초등학교",
  "서울창일초등학교",
  "서울창천초등학교",
  "서울천동초등학교",
  "서울천왕초등학교",
  "서울천일초등학교",
  "서울천호초등학교",
  "서울청계초등학교",
  "서울청구초등학교",
  "서울청담초등학교",
  "서울청덕초등학교",
  "서울청량초등학교",
  "서울청룡초등학교",
  "서울청운초등학교",
  "서울청파초등학교",
  "서울체육고등학교",
  "서울체육중학교",
  "서울초당초등학교",
  "서울충무초등학교",
  "서울치현초등학교",
  "서울컨벤션고등학교",
  "서울탑동초등학교",
  "서울탑산초등학교",
  "서울태랑초등학교",
  "서울태릉초등학교",
  "서울토성초등학교",
  "서울특별시교육청",
  "서울특별시교육청학생교육원",
  "서울평화초등학교",
  "서울포이초등학교",
  "서울풍납초등학교",
  "서울풍성초등학교",
  "서울하늘숲초등학교",
  "서울하늘초등학교",
  "서울학동초등학교",
  "서울한강초등학교",
  "서울한남초등학교",
  "서울한산초등학교",
  "서울한서초등학교",
  "서울한천초등학교",
  "서울항공비즈니스고등학교",
  "서울항동초등학교",
  "서울해누리초등학교",
  "서울행당초등학교",
  "서울행림초등학교",
  "서울행현초등학교",
  "서울혜화초등학교",
  "서울홍릉초등학교",
  "서울홍연초등학교",
  "서울홍은초등학교",
  "서울홍제초등학교",
  "서울홍파초등학교",
  "서울화계초등학교",
  "서울화곡초등학교",
  "서울화양초등학교",
  "서울화일초등학교",
  "서울효정학교",
  "서울효제초등학교",
  "서울후암초등학교",
  "서울휘경초등학교",
  "서울휘봉초등학교",
  "서울흑석초등학교",
  "서울흥인초등학교",
  "서일문화예술고등학교",
  "서일중학교",
  "서초고등학교",
  "서초문화예술정보학교",
  "서초중학교",
  "석관고등학교",
  "석관중학교",
  "석촌중학교",
  "선덕고등학교",
  "선덕중학교",
  "선린인터넷고등학교",
  "선린중학교",
  "선사고등학교",
  "선유고등학교",
  "선유중학교",
  "선일여자고등학교",
  "선일여자중학교",
  "선일이비즈니스고등학교",
  "선일초등학교",
  "선정고등학교",
  "선정국제관광고등학교",
  "선정중학교",
  "선화예술고등학교",
  "선화예술중학교",
  "성남고등학교",
  "성남중학교",
  "성내중학교",
  "성덕고등학교",
  "성덕여자중학교",
  "성동고등학교",
  "성동공업고등학교",
  "성동글로벌경영고등학교",
  "성동초등학교",
  "성베드로학교",
  "성보고등학교",
  "성보중학교",
  "성사중학교",
  "성산중학교",
  "성서중학교",
  "성수고등학교",
  "성수공업고등학교",
  "성수중학교",
  "성신여자고등학교",
  "성신여자중학교",
  "성신초등학교",
  "성심여자고등학교",
  "성심여자중학교",
  "성암국제무역고등학교",
  "성암여자중학교",
  "성원중학교",
  "성일중학교",
  "성재중학교",
  "성지중.고등학교(고)",
  "세곡중학교",
  "세그루패션디자인고등학교",
  "세륜중학교",
  "세명컴퓨터고등학교",
  "세일중학교",
  "세종과학고등학교",
  "세종초등학교",
  "세현고등학교",
  "세화고등학교",
  "세화여자고등학교",
  "세화여자중학교",
  "송곡고등학교",
  "송곡관광고등학교",
  "송곡여자고등학교",
  "송곡여자중학교",
  "송례중학교",
  "송정중학교",
  "송파공업고등학교",
  "송파중학교",
  "수도사랑의학교",
  "수도여자고등학교",
  "수도여자고등학교부설방송통신고등학교",
  "수도전기공업고등학교",
  "수락고등학교",
  "수락중학교",
  "수명고등학교",
  "수명중학교",
  "수서중학교",
  "수송중학교",
  "수유중학교",
  "숙명여자고등학교",
  "숙명여자중학교",
  "숭곡중학교",
  "숭문고등학교",
  "숭문중학교",
  "숭실고등학교",
  "숭실중학교",
  "숭의여자고등학교",
  "숭의여자중학교",
  "숭의초등학교",
  "숭인중학교",
  "시흥중학교",
  "신관중학교",
  "신광여자고등학교",
  "신광여자중학교",
  "신광초등학교",
  "신구중학교",
  "신길중학교",
  "신남중학교",
  "신도고등학교",
  "신도림고등학교",
  "신도림중학교",
  "신도봉중학교",
  "신도중학교",
  "신동신중.정보산업고등학교",
  "신동중학교",
  "신림고등학교",
  "신림중학교",
  "신명중학교",
  "신목고등학교",
  "신목중학교",
  "신반포중학교",
  "신방학중학교",
  "신사중학교",
  "신상중학교",
  "신서고등학교",
  "신서중학교",
  "신수중학교",
  "신암중학교",
  "신양중학교",
  "신연중학교",
  "신원중학교",
  "신월중학교",
  "신일고등학교",
  "신일중학교",
  "신정여자중학교",
  "신진과학기술고등학교",
  "신창중학교",
  "신천중학교",
  "신현고등학교",
  "신현중학교",
  "신화중학교",
  "아주중학교",
  "아현산업정보학교",
  "아현중학교",
  "아현중학교부설방송통신중학교",
  "안천중학교",
  "압구정고등학교",
  "압구정중학교",
  "양강중학교",
  "양동중학교",
  "양서중학교",
  "양원숲초등학교",
  "양재고등학교",
  "양정고등학교",
  "양정중학교",
  "양진중학교",
  "양천고등학교",
  "양천중학교",
  "양화중학교",
  "언남고등학교",
  "언남중학교",
  "언북중학교",
  "언주중학교",
  "여명학교",
  "여의도고등학교",
  "여의도여자고등학교",
  "여의도중학교",
  "역삼중학교",
  "연북중학교",
  "연서중학교",
  "연세대학교재활학교",
  "연신중학교",
  "연천중학교",
  "연희중학교",
  "염경중학교",
  "염광고등학교",
  "염광여자메디텍고등학교",
  "염광중학교",
  "염창중학교",
  "영남중학교",
  "영도중학교",
  "영동고등학교",
  "영동일고등학교",
  "영동중학교",
  "영등포고등학교",
  "영등포고등학교부설방송통신고등학교",
  "영등포공업고등학교",
  "영등포여자고등학교",
  "영등포중학교",
  "영락고등학교",
  "영락의료과학고등학교",
  "영락중학교",
  "영란여자중학교",
  "영림중학교",
  "영서중학교",
  "영신간호비즈니스고등학교",
  "영신고등학교",
  "영신여자고등학교",
  "영원중학교",
  "영일고등학교",
  "영파여자고등학교",
  "영파여자중학교",
  "영훈고등학교",
  "영훈국제중학교",
  "영훈초등학교",
  "예룸예술학교",
  "예림디자인고등학교",
  "예원학교",
  "예일디자인고등학교",
  "예일여자고등학교",
  "예일여자중학교",
  "예일초등학교",
  "예하예술학교",
  "오금고등학교",
  "오금중학교",
  "오남중학교",
  "오디세이학교학교",
  "오류고등학교",
  "오류중학교",
  "오륜중학교",
  "오산고등학교",
  "오산중학교",
  "오주중학교",
  "옥정중학교",
  "온곡중학교",
  "용강중학교",
  "용곡중학교",
  "용마중학교",
  "용문고등학교",
  "용문중학교",
  "용산고등학교",
  "용산중학교",
  "용산철도고등학교",
  "용화여자고등학교",
  "우신고등학교",
  "우신중학교",
  "우촌초등학교",
  "운현초등학교",
  "원묵고등학교",
  "원묵중학교",
  "원촌중학교",
  "월계고등학교",
  "월계중학교",
  "월곡중학교",
  "월촌중학교",
  "위례솔중학교",
  "유석초등학교",
  "유한공업고등학교",
  "윤중중학교",
  "은광여자고등학교",
  "은석초등학교",
  "은성중학교",
  "은평고등학교",
  "은평대영학교",
  "은평메디텍고등학교",
  "은평문화예술정보학교",
  "은평중학교",
  "은혜초등학교",
  "을지중학교",
  "이수중학교",
  "이화여자고등학교",
  "이화여자대학교병설미디어고등학교",
  "이화여자대학교사범대학부속이화·금란중학교",
  "이화여자대학교사범대학부속이화금란고등학교",
  "이화여자대학교사범대학부속초등학교",
  "이화여자외국어고등학교",
  "인덕과학기술고등학교",
  "인수중학교",
  "인왕중학교",
  "인창고등학교",
  "인창중학교",
  "인헌고등학교",
  "인헌중학교",
  "일신여자상업고등학교",
  "일신여자중학교",
  "자양고등학교",
  "자양중학교",
  "자운고등학교",
  "잠신고등학교",
  "잠신중학교",
  "잠실고등학교",
  "잠실여자고등학교",
  "잠실중학교",
  "잠일고등학교",
  "장승중학교",
  "장안중학교",
  "장원중학교",
  "장위중학교",
  "장충고등학교",
  "장충중학교",
  "장평중학교",
  "장훈고등학교",
  "재현고등학교",
  "재현중학교",
  "전농중학교",
  "전동중학교",
  "전일중학교",
  "정신여자고등학교",
  "정신여자중학교",
  "정원여자중학교",
  "정의여자고등학교",
  "정의여자중학교",
  "정화여자상업고등학교",
  "정화여자중학교",
  "종로산업정보학교",
  "종암중학교",
  "주몽학교",
  "중경고등학교",
  "중계중학교",
  "중동고등학교",
  "중동중학교",
  "중랑중학교",
  "중산고등학교",
  "중암중학교",
  "중앙고등학교",
  "중앙대학교사범대학부속고등학교",
  "중앙대학교사범대학부속중학교",
  "중앙대학교사범대학부속초등학교",
  "중앙여자고등학교",
  "중앙여자중학교",
  "중앙중학교",
  "중원중학교",
  "중평중학교",
  "중화고등학교",
  "중화중학교",
  "증산중학교",
  "지구촌학교",
  "진관고등학교",
  "진관중학교",
  "진명여자고등학교",
  "진선여자고등학교",
  "진선여자중학교",
  "진형중고등학교",
  "창덕여자고등학교",
  "창덕여자중학교",
  "창동고등학교",
  "창동중학교",
  "창문여자고등학교",
  "창문여자중학교",
  "창북중학교",
  "창일중학교",
  "창천중학교",
  "천왕중학교",
  "천일중학교",
  "천호중학교",
  "청담고등학교",
  "청담중학교",
  "청량고등학교",
  "청량정보고등학교",
  "청량중학교",
  "청암예술학교",
  "청암중고등학교",
  "청운중학교",
  "청원고등학교",
  "청원여자고등학교",
  "청원중학교",
  "청원초등학교",
  "추계초등학교",
  "충암고등학교",
  "충암중학교",
  "충암초등학교",
  "태강삼육초등학교",
  "태랑중학교",
  "태릉고등학교",
  "태릉중학교",
  "풍납중학교",
  "풍문고등학교",
  "풍성중학교",
  "하계중학교",
  "하나고등학교",
  "학력인정서현초등학교",
  "학력인정양원초등학교",
  "학력인정일성여자고등학교(2년제)",
  "학력인정정암미용고등학교(2년제)",
  "한가람고등학교",
  "한강미디어고등학교",
  "한강중학교",
  "한광고등학교",
  "한국구화학교",
  "한국삼육고등학교",
  "한국삼육중학교",
  "한국예술고등학교",
  "한국우진학교",
  "한국육영학교",
  "한국제과학교",
  "한림연예예술고등학교",
  "한빛맹학교",
  "한산미래학교",
  "한산중학교",
  "한서고등학교",
  "한성고등학교",
  "한성과학고등학교",
  "한성여자고등학교",
  "한성여자중학교",
  "한성중학교",
  "한세사이버보안고등학교",
  "한신초등학교",
  "한양공업고등학교",
  "한양대학교사범대학부속고등학교",
  "한양대학교사범대학부속중학교",
  "한양중학교",
  "한양초등학교",
  "한영고등학교",
  "한영외국어고등학교",
  "한영중학교",
  "한울중학교",
  "한천중학교",
  "항동중학교",
  "해누리중학교",
  "해성국제컨벤션고등학교",
  "해성여자고등학교",
  "행당중학교",
  "현대고등학교",
  "혜성여자고등학교",
  "혜원여자고등학교",
  "혜원여자중학교",
  "혜화여자고등학교",
  "홍은중학교",
  "홍익대학교사범대학부속고등학교",
  "홍익대학교사범대학부속여자고등학교",
  "홍익대학교사범대학부속여자중학교",
  "홍익대학교사범대학부속중학교",
  "홍익대학교사범대학부속초등학교",
  "홍익디자인고등학교",
  "화계중학교",
  "화곡고등학교",
  "화곡보건경영고등학교",
  "화곡중학교",
  "화랑초등학교",
  "화원중학교",
  "환일고등학교",
  "환일중학교",
  "효문고등학교",
  "효문중학교",
  "휘경공업고등학교",
  "휘경여자고등학교",
  "휘경여자중학교",
  "휘경중학교",
  "휘문고등학교",
  "휘문중학교",
  "휘봉고등학교",
];
export const IEN_ORGANIZATIONS = [
  "전체",
  "인천부내초등학교",
  "연성중학교",
  "인천하늘중학교",
  "인천현송초등학교",
  "부평고등학교",
  "도화기계공업고등학교",
  "도림고등학교",
  "덕신고등학교",
  "학익고등학교",
  "백석고등학교",
  "인천비즈니스고등학교",
  "인천만수고등학교",
  "인천정보산업고등학교",
  "인평자동차고등학교",
  "인천생활과학고등학교",
  "작전고등학교",
  "강남영상미디어고등학교",
  "한국주얼리고등학교",
  "인천논현고등학교",
  "옥련여자고등학교",
  "삼량고등학교",
  "신송고등학교",
  "서인천고등학교",
  "송도고등학교",
  "연평고등학교",
  "인천부평동초등학교",
  "인천대정초등학교",
  "인천동막초등학교",
  "인천공항초등학교신도분교장",
  "인천굴포초등학교",
  "인천구월서초등학교",
  "합일초등학교",
  "화도초등학교",
  "인천효성초등학교",
  "인천백석초등학교",
  "인천청량초등학교",
  "인천동방초등학교",
  "인천도화초등학교",
  "인천도림초등학교",
  "인천중산초등학교",
  "인천조동초등학교",
  "인천만석초등학교",
  "인천옥련초등학교",
  "인천석암초등학교",
  "인천십정초등학교",
  "인천숭의초등학교",
  "인천소래초등학교",
  "인천영종초등학교금산분교장",
  "인천연화초등학교",
  "안남고등학교",
  "박문여자고등학교",
  "부광고등학교",
  "부광여자고등학교",
  "부평여자고등학교",
  "인천부흥초등학교",
  "인천봉수초등학교",
  "백령고등학교",
  "부개고등학교",
  "부개여자고등학교",
  "인천부흥고등학교",
  "인천청담고등학교",
  "인천청라고등학교",
  "인천초은고등학교",
  "청학공업고등학교",
  "대인고등학교",
  "덕적고등학교",
  "동인천고등학교",
  "동산고등학교",
  "인천은광학교",
  "인천금융고등학교",
  "가정고등학교",
  "가좌고등학교",
  "강화여자고등학교",
  "강화고등학교",
  "가림고등학교",
  "검단고등학교",
  "인천고잔고등학교",
  "인천공항고등학교",
  "계양고등학교",
  "계산고등학교",
  "인천해밀학교",
  "학익여자고등학교",
  "인천한누리학교",
  "인천과학예술영재학교",
  "인천뷰티예술고등학교",
  "인천청인학교",
  "인천미래생활고등학교",
  "인천청선학교",
  "인천석정초등학교",
  "인천대건고등학교",
  "대청고등학교",
  "인천여자상업고등학교",
  "인천보건고등학교",
  "인천해송고등학교",
  "인천하이텍고등학교",
  "인천국제고등학교",
  "인천중앙여자상업고등학교",
  "인천진산과학고등학교",
  "계산공업고등학교",
  "인천남고등학교",
  "인천예술고등학교",
  "인천고등학교",
  "인천여자고등학교",
  "인천상정고등학교",
  "인천디자인고등학교",
  "인천인동초등학교",
  "인천기계공업고등학교",
  "인하대학교사범대학부속고등학교",
  "인항고등학교",
  "인화여자고등학교",
  "인천인혜학교",
  "인천효성고등학교",
  "인일여자고등학교",
  "인제고등학교",
  "인명여자고등학교",
  "인천전자마이스터고등학교",
  "인천과학고등학교",
  "인천신현고등학교",
  "인천세원고등학교",
  "인천세무고등학교",
  "인천연송고등학교",
  "제물포고등학교",
  "제일고등학교",
  "작전여자고등학교",
  "인천재능고등학교",
  "정석항공과학고등학교",
  "광성고등학교",
  "계산여자고등학교",
  "교동고등학교",
  "인천마전고등학교",
  "인천해양과학고등학교",
  "미추홀외국어고등학교",
  "미추홀학교",
  "인천마전초등학교",
  "인천목향초등학교",
  "문일여자고등학교",
  "명신여자고등학교",
  "문학정보고등학교",
  "인천체육고등학교",
  "부평공업고등학교",
  "삼산고등학교",
  "인천산곡고등학교",
  "산마을고등학교",
  "인천산업정보학교",
  "인천성동학교",
  "세일고등학교",
  "서도고등학교",
  "인천서희학교",
  "서운고등학교",
  "인천산곡북초등학교",
  "인천신정초등학교",
  "신명여자고등학교",
  "석정여자고등학교",
  "인천송천고등학교",
  "숭덕여자고등학교",
  "선인고등학교",
  "인천원당고등학교",
  "인천약산초등학교",
  "인천예일고등학교",
  "인천영종고등학교",
  "연수여자고등학교",
  "연수고등학교",
  "인천예림학교",
  "인천용현남초등학교",
  "영종국제물류고등학교",
  "인천연일학교",
  "인천영흥고등학교",
  "영화국제관광고등학교",
  "인천영선고등학교",
  "구산중학교",
  "인천석천초등학교",
  "인천석남중학교",
  "인천안남초등학교",
  "인천안남중학교",
  "인천백학초등학교",
  "박문중학교",
  "백석중학교",
  "인천부현동초등학교",
  "북인천여자중학교",
  "부평중학교",
  "부평여자중학교",
  "인천부평서초등학교",
  "부평서여자중학교",
  "백령중학교",
  "인천부평북초등학교",
  "인천부개초등학교",
  "인천부개서초등학교",
  "북인천중학교",
  "인천부곡초등학교",
  "부광중학교",
  "인천부광초등학교",
  "인천부현초등학교",
  "부일중학교",
  "부일여자중학교",
  "북포초등학교",
  "불은초등학교",
  "인천불로초등학교",
  "불로중학교",
  "인천부평남초등학교",
  "부평동중학교",
  "부평서중학교",
  "부원중학교",
  "부원여자중학교",
  "인천축현초등학교",
  "인천창영초등학교",
  "인천청학초등학교",
  "인천첨단초등학교",
  "청천중학교",
  "청학중학교",
  "인천청일초등학교",
  "인천청라초등학교",
  "인천청라중학교",
  "인천청람초등학교",
  "청량중학교",
  "인천초은초등학교",
  "인천초은중학교",
  "조산초등학교",
  "인천창신초등학교",
  "인천대화초등학교",
  "인천담방초등학교",
  "인천단봉초등학교",
  "인천당하초등학교",
  "인천당하중학교",
  "인천당산초등학교",
  "덕적중학교",
  "동인천여자중학교",
  "인천도담초등학교",
  "인천동암초등학교",
  "동암중학교",
  "인천동부초등학교",
  "동인천중학교",
  "동광중학교",
  "동산중학교",
  "인천동수초등학교",
  "인천은지초등학교",
  "갑룡초등학교",
  "인천가현중학교",
  "인천가현초등학교",
  "가정여자중학교",
  "인천갈월초등학교",
  "강화초등학교",
  "강화중학교",
  "강남중학교",
  "간재울중학교",
  "간석여자중학교",
  "인천가원초등학교",
  "인천검암초등학교",
  "검암중학교",
  "검단중학교",
  "인천건지초등학교",
  "인천금마초등학교",
  "인천금곡초등학교",
  "강화여자중학교",
  "인천길주초등학교",
  "길상초등학교",
  "인천가좌초등학교",
  "인천가정초등학교",
  "인천간재울초등학교",
  "인천공촌초등학교",
  "인천공항중학교",
  "인천공항초등학교",
  "인천공항유치원",
  "인천가석초등학교",
  "인천검단초등학교",
  "구월중학교",
  "구월여자중학교",
  "인천계산초등학교",
  "계산여자중학교",
  "인천계수중학교",
  "인천계양초등학교",
  "계양중학교",
  "인천귤현초등학교",
  "인천해송중학교",
  "인천해원초등학교",
  "인천해원중학교",
  "인천학익초등학교",
  "하점초등학교",
  "인천함박초등학교",
  "함박중학교",
  "해명초등학교",
  "인천한길초등학교",
  "인천하정초등학교",
  "인천효성동초등학교",
  "인천해송초등학교",
  "인천효성남초등학교",
  "인천효성서초등학교",
  "인천후정초등학교",
  "화도진중학교",
  "인천화전초등학교",
  "인천아암초등학교",
  "인천안산초등학교",
  "인천발산초등학교",
  "인천병방초등학교",
  "인천봉화초등학교",
  "인천부평초등학교",
  "부흥중학교",
  "인천백운초등학교",
  "인천청천초등학교",
  "인천천마초등학교",
  "인천여자중학교",
  "청라유치원",
  "인천남중학교",
  "인천청람중학교",
  "인천신촌초등학교",
  "인천신흥초등학교",
  "대월초등학교",
  "인천동춘초등학교",
  "대청중학교",
  "인천동양중학교",
  "인천은봉초등학교",
  "인천장서초등학교",
  "인천갈산초등학교",
  "인천가림초등학교",
  "관교여자중학교",
  "인천개흥초등학교",
  "인천고잔유치원",
  "인천경명초등학교",
  "인천간석초등학교",
  "인천구산초등학교",
  "인천구월유치원",
  "인천경원초등학교",
  "인천경연초등학교",
  "인천경연중학교",
  "인천학산초등학교",
  "인천한빛초등학교",
  "인천화전유치원",
  "인천해서초등학교",
  "인천효성중학교",
  "인천중앙초등학교",
  "인천진산초등학교",
  "인천고잔중학교",
  "인천구월초등학교",
  "인천명현초등학교",
  "인천명선초등학교",
  "인천남부초등학교",
  "인천남촌초등학교",
  "인천논현초등학교",
  "인천논현중학교",
  "인주중학교",
  "인천인주초등학교",
  "인천인수초등학교",
  "인성여자중학교",
  "인천용정초등학교",
  "인천삼산초등학교",
  "삼산중학교",
  "인천상정중학교",
  "인천서창중학교",
  "인천일신초등학교",
  "인천송현초등학교",
  "인천신정중학교",
  "인천송명초등학교",
  "인천석남서초등학교",
  "인천원당초등학교",
  "인천양촌초등학교",
  "인천예송유치원",
  "인천용현초등학교",
  "인천양지초등학교",
  "인천영선초등학교",
  "인천연성초등학교",
  "인천주안북초등학교",
  "인천작전초등학교",
  "인천작동초등학교",
  "작전중학교",
  "인천장아초등학교",
  "인천장도초등학교",
  "인천장수초등학교",
  "자유유치원",
  "인천재능중학교",
  "제물포중학교",
  "인천정각중학교",
  "인천정각초등학교",
  "진산중학교",
  "제물포여자중학교",
  "인천주안초등학교",
  "인천주안남초등학교",
  "인천주안남초등학교승봉분교장",
  "인천중산중학교",
  "인천주원초등학교",
  "가좌중학교",
  "강서중학교",
  "교동초등학교",
  "인천가좌여자중학교",
  "인천고잔초등학교",
  "관교중학교",
  "인천관교초등학교",
  "인천경서초등학교",
  "계산중학교",
  "교동중학교",
  "인천마곡초등학교",
  "인천마장초등학교",
  "마전중학교",
  "마니산유치원",
  "만성중학교",
  "인천만수초등학교",
  "만수중학교",
  "인천만월초등학교",
  "명현중학교",
  "인천미산초등학교",
  "인천미송초등학교",
  "인천만수북초등학교",
  "만수여자중학교",
  "인천문학초등학교",
  "인천문남초등학교",
  "인천먼우금초등학교",
  "내가초등학교",
  "남동중학교",
  "인천남동초등학교",
  "남인천여자중학교",
  "인천능내초등학교",
  "인천능허대초등학교",
  "능허대중학교",
  "논현유치원",
  "논곡중학교",
  "인천논곡초등학교",
  "옥련중학교",
  "인천부일초등학교",
  "인천부원초등학교",
  "인천새말초등학교",
  "삼산초등학교",
  "삼산유치원",
  "삼성초등학교",
  "인천상아초등학교",
  "상인천초등학교",
  "인천산곡초등학교",
  "산곡중학교",
  "인천산곡남초등학교",
  "인천사리울초등학교",
  "인천송천초등학교",
  "서도초등학교",
  "인천서창초등학교",
  "서도중학교",
  "서곶중학교",
  "인천서흥초등학교",
  "인천서현유치원",
  "석정중학교",
  "인천선학초등학교",
  "인천서림초등학교",
  "인천서운초등학교",
  "서운중학교",
  "삼산승영중학교",
  "인천서곶초등학교",
  "산곡남중학교",
  "신흥중학교",
  "인천승학초등학교",
  "신현여자중학교",
  "신흥여자중학교",
  "인천신현초등학교",
  "인천신현북초등학교",
  "신송중학교",
  "인천신월초등학교",
  "선학중학교",
  "인천서화초등학교",
  "상인천중학교",
  "상인천여자중학교",
  "심도중학교",
  "인천심곡초등학교",
  "인천신대초등학교",
  "인천신석초등학교",
  "인천신선초등학교",
  "인천성지초등학교",
  "인천상정초등학교",
  "인천신광초등학교",
  "인천하늘초등학교",
  "인천삼목초등학교",
  "인천삼목초등학교장봉분교장",
  "인천서면초등학교",
  "인천송도초등학교",
  "송도중학교",
  "송해초등학교",
  "인천송일초등학교",
  "인천송림초등학교",
  "인천송월초등학교",
  "인천송원초등학교",
  "숭덕여자중학교",
  "인천소양초등학교",
  "인천사리울중학교",
  "인천신송초등학교",
  "인천석남초등학교",
  "인천성리초등학교",
  "인천성리중학교",
  "선화여자중학교",
  "선인중학교",
  "선원초등학교",
  "인천운서초등학교",
  "인천왕길초등학교",
  "원당중학교",
  "인천완정초등학교",
  "인천원동초등학교",
  "인천운남초등학교",
  "광성중학교",
  "임학중학교",
  "인천양촌중학교",
  "양도초등학교",
  "인천예일중학교",
  "영종유치원",
  "인천연학초등학교",
  "인천연송초등학교",
  "인천연수초등학교",
  "연수중학교",
  "인천예송초등학교",
  "인천예송중학교",
  "인천용학초등학교",
  "용현여자중학교",
  "연화중학교",
  "인천용현남초등학교자월분교장",
  "인천영종초등학교",
  "인천용마초등학교",
  "인천연안초등학교",
  "용현중학교",
  "인천용일초등학교",
  "인천용유초등학교",
  "용유중학교",
  "영흥중학교",
  "영종중학교",
  "연평중학교",
  "양사초등학교",
  "백령초등학교",
  "대청초등학교",
  "덕적초등학교",
  "인천혜광학교",
  "인천해원고등학교",
  "인천중학교",
  "인하대학교사범대학부속중학교",
  "인화여자중학교",
  "인송중학교",
  "인성여자고등학교",
  "갈산중학교",
  "만월중학교",
  "명신초등학교",
  "산곡여자중학교",
  "신현중학교",
  "영흥초등학교",
  "연평초등학교",
  "인천청호초등학교",
  "인천청호중학교",
  "인천중산고등학교",
  "인천미송중학교",
  "푸른빛유치원",
  "인천송도꿈유치원",
  "인천송담초등학교",
  "인천부마초등학교",
];

export const enumCompetitionType = {
  None: "None",
  "2024 하반기 인천 메타버스 앱 창작 챌린지": "ICMA2024",
};
